import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_TEAM](state, payload) {
    state.team = payload;
  },
  [MutationsType.SET_TEAMS](state, payload) {
    state.teams = payload;
  },
  [MutationsType.ADD_TEAM](state, payload) {
    state.teams.push(payload);
  },
  [MutationsType.UPDATE_TEAM](state, payload) {
    let ind = state.teams.findIndex((team) => team.id === payload.id);
    if (ind >= 0) Vue.set(state.teams, ind, { ...state.teams[ind], ...payload });
  },
  [MutationsType.SET_SCHEMA_TICKET_FORM](state, payload) {
    state.schemaTicketForm = payload;
  },
  [MutationsType.SET_FIELD_SCHEMA_TICKET_FORM](state, payload) {
    state.fieldSchemaTicketForm = payload;
  },
  [MutationsType.ADD_TICKET_FORM_FIELD](state, payload) {
    if (state.schemaTicketForm) state.schemaTicketForm.unshift(payload);
  },
  [MutationsType.ADD_TICKET_IMPORT_FIELD](state, payload) {
    if (state.schemaTicketImport) state.schemaTicketImport.unshift(payload);
  },
  [MutationsType.UPDATE_TICKET_FORM_FIELD](state, payload) {
    let ind = (state.schemaTicketForm || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.schemaTicketForm, ind, payload);
  },
  [MutationsType.DETELE_TICKET_FORM_FIELD](state, payload) {
    let ind = (state.schemaTicketForm || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) state.schemaTicketForm.splice(ind, 1);
  },
  [MutationsType.SET_SCHEMA_CONTACT_FORM](state, payload) {
    state.schemaContactForm = payload;
  },
  [MutationsType.SET_SCHEMA_TICKET_EXPORT](state, payload) {
    state.schemaTicketExport = payload;
  },
  [MutationsType.SET_SCHEMA_CONTACT_EXPORT](state, payload) {
    state.schemaContactExport = payload;
  },
  [MutationsType.SET_SCHEMA_TICKET_FILTERS](state, payload) {
    state.schemaTicketFilters = payload;
  },
};
